import React from "react";
import "./IndustrailConsuting.css"; // Assuming you have a CSS file for styling

const IndustrailConsuting = () => {
  return (
    <div>
      <section className="common-page-hero">
        <img
          src="assets/img/service/mw7.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Courses".split("").map((char, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>
              </p>
              <br />
              <p
                className="mini-title1"
                style={{
                  backgroundColor: "rgb(232, 119, 34)",
                  color: "white",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  display: "inline-block",
                  borderRadius: "5px",
                }}
              >
                SEMANTIC Skills Junction
              </p>
              <br />
              <h2
                className="ak-section-title animation-title"
                style={{ fontSize: "45px", perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"SEMANTIC Skills Junction: Bridging"
                    .split(" ")
                    .map((word, idx1) => (
                      <span
                        key={idx1}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        {word.split("").map((char, idx2) => (
                          <div
                            key={idx2}
                            style={{
                              position: "relative",
                              display: "inline-block",
                              transform: "translate(0px, 0px)",
                              opacity: 1,
                            }}
                          >
                            {char}
                          </div>
                        ))}
                        &nbsp;
                      </span>
                    ))}
                </div>
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Talent and Technology".split(" ").map((word, idx1) => (
                    <span
                      key={idx1}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {word.split("").map((char, idx2) => (
                        <div
                          key={idx2}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            transform: "translate(0px, 0px)",
                            opacity: 1,
                          }}
                        >
                          {char}
                        </div>
                      ))}
                      &nbsp;
                    </span>
                  ))}
                </div>
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Course
            </p>
          </div>
          <a href="tel:+917619617023" className="phone-number">
            (+91) 7619617023
          </a>
        </div>
      </section>

      <div className="strategic-points">
        <div className="points-card">
          <h2 className="points-title" style={{ fontSize: "38px" }}>
            INDUSTRY CONSULTING, QUALITY MANAGEMENT SYSTEM [QMS] SUPPORT
          </h2>
          <div className="points-container">
            <div className="point-item">
              <p style={{ marginBottom: "10px" }}>
                <span
                  style={{
                    color: "rgb(179, 0, 0)",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  ➤ Pilot plant setup
                </span>{" "}
                –{" "}
                <span
                  style={{ color: "black", fontSize: "18px", fontWeight: 500 }}
                >
                  Cleanroom, Equipment identification, Equipment installation,
                  Process Qualification
                </span>
              </p>
            </div>
            <div className="point-item">
              <p style={{ marginBottom: "10px" }}>
                <span
                  style={{
                    color: "rgb(179, 0, 0)",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  ➤ Process setup, Technology Transfers
                </span>{" "}
                –{" "}
                <span
                  style={{ color: "black", fontSize: "18px", fontWeight: 500 }}
                >
                  Wafer Fab and OSAT / ATMP
                </span>
              </p>
            </div>
            <div className="point-item">
              <p style={{ marginBottom: "10px" }}>
                <span
                  style={{
                    color: "rgb(179, 0, 0)",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  ➤ Setup and sustain Quality Management System
                </span>{" "}
                –{" "}
                <span
                  style={{ color: "black", fontSize: "18px", fontWeight: 500 }}
                >
                  Quality Management System
                </span>
              </p>
            </div>
            <div className="point-item">
              <p style={{ marginBottom: "10px" }}>
                <span
                  style={{
                    color: "rgb(179, 0, 0)",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  ➤ Continuous Improvement Programs
                </span>{" "}
                –{" "}
                <span
                  style={{ color: "black", fontSize: "18px", fontWeight: 500 }}
                >
                  Yield, Cost Optimization, Factory KPIs
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <section>
  <div className="container">
    <div className="testmonial-top-content" style={{ display: "block" }}>
      <div className="ak-section-heading ak-style-1 animation-title-content animation-style3"></div>
      <div style={{ marginTop: "15px", fontSize: "20px" }}>
        We provide specialized advisory and mentorship services to help grow India's semiconductor and ESDM (Electronic System Design and Manufacturing) ecosystem by leveraging our expertise and Taiwan-based support.
      </div>
    </div>

    <div className="testmonial-content ak-slider ak-slider-testmonial swiper-creative swiper-3d swiper-initialized swiper-horizontal swiper-pointer-events swiper-watch-progress" style={{ marginTop: "20px" }}>
      <div className="swiper-wrapper" id="swiper-wrapper-ce96632b0ece9ca3" aria-live="polite">
        
        {/* Slide 1 */}
        <div className="swiper-slide" data-swiper-slide-index="0" role="group" aria-label="1 / 2">
          <div className="testmonial-slider">
            <div className="testmonial-img">
              <img src="./assets/img/bg/mans.png" data-swiper-parallax="200" alt="..." />
            </div>
            <div className="testmonial-info">
              <section className="slide">
                <h3>Pilot Plant Setup and Process Setup</h3>
                <h4 style={{ marginTop: "10px", marginLeft: "20px", lineHeight: 1.5 }}>Pilot Plant Setup</h4>
                <ul style={{ marginLeft: "30px" }}>
                  <li>Cleanroom establishment</li>
                  <li>Equipment identification & installation</li>
                  <li>Process qualification</li>
                </ul>
                <h4 style={{ marginTop: "10px", marginLeft: "20px", lineHeight: 1.5 }}>Process Setup & Technology Transfers</h4>
                <ul style={{ marginLeft: "30px" }}>
                  <li>Wafer Fab setup</li>
                  <li>OSAT/ATMP technology transfer</li>
                </ul>
              </section>
            </div>
          </div>
        </div>

        {/* Slide 2 */}
        <div className="swiper-slide" data-swiper-slide-index="1" role="group" aria-label="2 / 2">
          <div className="testmonial-slider">
            <div className="testmonial-img">
              <img src="./assets/img/bg/hc.jpg" data-swiper-parallax="200" alt="..." />
            </div>
            <div className="testmonial-info">
              <section className="slide">
                <h3>Quality Management and Continuous Improvement</h3>
                <h4 style={{ marginTop: "10px", marginLeft: "20px", lineHeight: 1.5 }}>Quality Management System (QMS) Support</h4>
                <ul style={{ marginLeft: "30px" }}>
                  <li>Setup and sustain QMS</li>
                  <li>Compliance with industry standards</li>
                </ul>
                <h4 style={{ marginTop: "10px", marginLeft: "20px", lineHeight: 1.5 }}>Continuous Improvement Programs</h4>
                <ul style={{ marginLeft: "30px" }}>
                  <li>Yield optimization</li>
                  <li>Cost optimization</li>
                  <li>Monitoring Factory KPIs for better productivity</li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Slider Navigation */}
      <div className="testmonial-controller" style={{ marginTop: "20px" }}>
        <div className="testmonial-swiper-controller">
          <button className="testmonial-next-btn slider-btn next" aria-label="Next slide" aria-controls="swiper-wrapper-ce96632b0ece9ca3">
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74" stroke="#030917" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <button className="testmonial-prev-btn slider-btn prev" aria-label="Previous slide" aria-controls="swiper-wrapper-ce96632b0ece9ca3">
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74" stroke="#030917" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>

      <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
    </div>
  </div>
</section>


    </div>
  );
};

export default IndustrailConsuting;
